import { useEffect, useState } from "react";
import styles from "../../../ProductsDetails.module.css";
import { useTranslation } from "react-i18next";
import AnimatedDetailsText from "../../../AnimatedDetailsText";
import ModelSlider from "../../../ModelSlider";

function IoHotel() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [imagesLoaded, setImagesLoaded] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleImageLoad = (index) => {
    setImagesLoaded((prevState) => ({
      ...prevState,
      [index]: true,
    }));
  };
  const { t } = useTranslation();
  const imageData = [
    {
      img: isSmallScreen ? "01.jpg" : "01.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle1`),
      top: isSmallScreen ? "16%" : "22%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },

    {
      img: isSmallScreen ? "02.jpg" : "02.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle2`),
      top: isSmallScreen ? "25%" : "29%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },

    {
      img: isSmallScreen ? "03.jpg" : "03.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle3`),
      top: isSmallScreen ? "20%" : "50%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "70%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#fff",
    },

    {
      img: isSmallScreen ? "04.jpg" : "04.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle4`),
      top: isSmallScreen ? "17%" : "65%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },

    {
      img: isSmallScreen ? "05.jpg" : "05.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle5`),
      top: isSmallScreen ? "82%" : "50%",
      left: isSmallScreen ? "50%" : "82%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "06.jpg" : "06.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle6`),
      top: isSmallScreen ? "88%" : "65%",
      left: isSmallScreen ? "50%" : "28%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#fff",
    },
    {
      img: isSmallScreen ? "07.jpg" : "07.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle7`),
      top: isSmallScreen ? "22%" : "50%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#fff",
    },
    {
      img: isSmallScreen ? "08.jpg" : "08.jpg",
      title: "",
      subtitle: t(`hotelIo.subtitle8`),
      top: isSmallScreen ? "18%" : "50%",
      left: isSmallScreen ? "50%" : "80%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
  ];

  const basePath = `${process.env.PUBLIC_URL}/images/01-tis-bus/hotel-interface-details/io-Hotel-series`;
  const smallScreenPath = `${basePath}/smallScreens`;

  const modelsData = [
    {
      id: 1,
      name: "IO-8G",
      image: `${basePath}/models/01.png`,
    },
    {
      id: 2,
      name: "IO-AC-4G",
      image: `${basePath}/models/02.png`,
    },
    {
      id: 3,
      name: "IO-CARD-3SRV",
      image: `${basePath}/models/03.png`,
    },
    {
      id: 4,
      name: "IO-OUT-HOTEL",
      image: `${basePath}/models/04.png`,
    },
    {
      id: 5,
      name: "IO-OUT-HOTEL-RF",
      image: `${basePath}/models/05.png`,
    },
  ];
  return (
    <div className={styles.container}>
      {imageData.map((item, index) => (
        <div
          key={index}
          className={styles.imgContainer}
          style={{ position: "relative", width: "100vw", display: "block" }}
        >
          {item.isVideo ? (
            <VideoAsGif
              className={styles.videoContainer}
              style={{ width: "100vw" }}
              videoSrc={`${basePath}/${item.img}`}
            />
          ) : (
            <img
              style={{
                width: "100vw",
                marginRight: isSmallScreen ? "0" : "0",
                paddingLeft: isSmallScreen ? "0" : "0",
              }}
              src={
                isSmallScreen
                  ? `${smallScreenPath}/${item.img}`
                  : `${basePath}/${item.img}`
              }
              alt=""
              onLoad={() => handleImageLoad(index)}
            />
          )}
          {imagesLoaded[index] && (
            <div
              style={{
                position: "absolute",
                top: item.top,
                left: item.left,
                transform: "translate(-50%, -50%)",
                textAlign: item.textAlign,
                width: item.width,
              }}
            >
              <AnimatedDetailsText
                text={{
                  title: item.title,
                  subtitle: item.subtitle,
                }}
                color={item.color || "#000"}
                textAlign={item.textAlign}
                margin="20px 0"
                padding="10px"
                direction={item.direction}
                fontSize={item.fontSize || "20px"}
                zoom={item.zoom}
              />
            </div>
          )}
          {/* عرض مكون ModelSlider بعد الصورة الأولى فقط */}
          {index === 0 && (
            <div style={{ textAlign: "center" }}>
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  marginTop: "40px",
                }}
              >
                Product Models
              </h1>
              <div>
                <ModelSlider models={modelsData} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default IoHotel;

const VideoAsGif = ({ videoSrc, className }) => {
  return (
    <div className={styles.videoContainer}>
      <video
        className={styles.fullscreenVideo}
        autoPlay
        muted
        loop
        playsInline // مهم لأجهزة iPhone
        disablePictureInPicture // منع خاصية "صورة داخل صورة"
        controls={false} // إخفاء أزرار التحكم
        style={{ display: "block", width: "100%" }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
